module.exports = __webpack_public_path__ + "static/media/leave.00247063.svg";